import React, { useLayoutEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

export default function Router({ history, ...props }) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <BrowserRouter
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
}
